import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'

// Sentry io
import * as Sentry from '@sentry/react'

// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
import {CookieConsentProvider} from './app/context/CookieConsentContext'
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios)
Chart.register(...registerables)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data stays in cache for 30 minutes
      cacheTime: 30 * 60 * 1000,
      // Data is considered fresh for 10 minutes
      staleTime: 10 * 60 * 1000,
      // Don't refetch on window focus for global data
      refetchOnWindowFocus: false,
      // Retry failed requests up to 2 times
      retry: 2,
    },
  },
})

let sentryProjectUrl =
  process.env.REACT_APP_SENTRY_PROJECT_URL ||
  ''
  
// Init Sentry
Sentry.init({
  dsn: sentryProjectUrl,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  environment: process.env.NODE_ENV,
  sendDefaultPii: true,
  enableLogs: true,
})

console.log("NODE_ENV:", process.env.NODE_ENV);

const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <MetronicI18nProvider>
        <CookieConsentProvider>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </CookieConsentProvider>
      </MetronicI18nProvider>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  )
}
